import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';
import { toast } from 'sonner';

export const CHANGE_PASSWORD_MUTATION = gql`
  mutation ChangePassword($input: ChangePasswordInput!) {
    changePassword(input: $input) {
      success
    }
  }
`;

export function useChangePassword(options?: { onCompleted?: () => void }) {
  const [changePasswordMutation, { loading }] = useMutation(CHANGE_PASSWORD_MUTATION, {
    onCompleted: options?.onCompleted,
    onError: (error: any) => {
      const message = error.graphQLErrors?.[0]?.message || error.message || 'Falha ao alterar senha';
      toast.error(message);
    },
  });

  const changePassword = (currentPassword: string, password: string, passwordConfirmation: string) => {
    return changePasswordMutation({
      variables: { input: { currentPassword, password, passwordConfirmation } },
    });
  };

  return { changePassword, loading };
}
